import React from 'react'
import About from '../../organisms/About'
import Head from 'next/head'

function index() {
  return (
    <>
      <Head>
        <title>KashKounter - Never pay full price again. Shop, save and earn upto 40% cashback!</title>
      </Head>
      <About />
    </>
  )
}

export default index